import type { MediaImageInterface } from '@hypercodestudio/basler-components';

import { generateImageObject } from '~/utils/generateImageObject';
import { lightingAdvisorOptionImageOptions } from '~/utils/imagePresetRegistry';
import { ALL_LIGHT_TYPE_VALUES } from '~/utils/lightingAdvisor/constants';

const LIGHT_TYPE_VALUES = new Set<string>(ALL_LIGHT_TYPE_VALUES);
// Intrinsic dimensions of the imported source assets; needed to reserve layout
// space before the illustration loads.
const LIGHT_TYPE_IMAGE_SIZE = { width: 1380, height: 735 } as const;
const APPLICATION_IMAGE_SIZE = { width: 612, height: 326 } as const;

/**
 * Builds selectable illustrations from already resolved Contentful asset URLs,
 * keyed by the tools API option value.
 */
export function buildLightingAdvisorOptionImages(
  urlsByOptionValue: Readonly<Partial<Record<string, string | null>>>
): Partial<Record<string, MediaImageInterface>> {
  const result: Partial<Record<string, MediaImageInterface>> = {};

  for (const [value, url] of Object.entries(urlsByOptionValue)) {
    if (!url) {
      continue;
    }
    const dimensions = LIGHT_TYPE_VALUES.has(value)
      ? LIGHT_TYPE_IMAGE_SIZE
      : APPLICATION_IMAGE_SIZE;
    const media = generateImageObject(
      {
        url,
        ...dimensions
      },
      lightingAdvisorOptionImageOptions
    );
    if (media) {
      result[value] = media.content;
    }
  }

  return result;
}
